// extracted by mini-css-extract-plugin
export default {"alertContainer":"alertContainer-ab3DO","alert":"alert-yicfs"};